
import {SET_PLANE_MACROS} from 'constants/action-types.js';


export default (state = {macros: {}}, action) => {
    switch (action.type) {
    case SET_PLANE_MACROS:
        let macros = state.macros || {};
        macros[action.payload.id] = action.payload.macros;
        return {
            ... state,
            macros
        };
    default:
        return state;
    }
}
